import { render, staticRenderFns } from "./SendSmsButton.vue?vue&type=template&id=b3c18b22&scoped=true&"
import script from "./SendSmsButton.vue?vue&type=script&lang=js&"
export * from "./SendSmsButton.vue?vue&type=script&lang=js&"
import style0 from "./SendSmsButton.vue?vue&type=style&index=0&id=b3c18b22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3c18b22",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b3c18b22')) {
      api.createRecord('b3c18b22', component.options)
    } else {
      api.reload('b3c18b22', component.options)
    }
    module.hot.accept("./SendSmsButton.vue?vue&type=template&id=b3c18b22&scoped=true&", function () {
      api.rerender('b3c18b22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Orders/Buttons/SendSmsButton.vue"
export default component.exports